<template>
  <div style="font-size: 13px;line-height:30px">
    <el-row>
      <span>承运商账单编号：<label class="primaryfont">{{ formData.carrierStatementNo }}</label></span>
    </el-row>

    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>承运商名称：{{ formData.carrierName }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>负责机构名称：{{ formData.orgName }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span
          >账单开始-结束日期：{{ formData.beginDate + '~' + formData.endDate }}</span
        >
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>生成时间：{{ formData.builderTime }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>应付运费合计：{{ formData.payAmount }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>应付费用合计：{{ formData.payCostAmount }}</span>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span>应付合计：{{ formData.payTotalAmount }}</span>
      </el-col>

      <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
        <span
          >账单状态：{{
            formData.carrierStatementStatus === 'Y'
              ? '已付款'
              : formData.carrierStatementStatus === 'N'
              ? '新增'
              : formData.carrierStatementStatus === 'P'
              ? '收到发票'
              : ''
          }}</span
        >
        <!-- <el-form-item label="账单状态" prop="carrierStatementStatus">
          <br />
          <el-radio-group v-model="formData.carrierStatementStatus">
            <el-radio label="Y">已付款</el-radio>
            <el-radio label="N">新增</el-radio>
            <el-radio label="P">收到发票</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    params: {type: Object, default: () => {}},
    isDisabled: Boolean,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {carrierStatementStatus: 'N', totalLength: 0},
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.params.carrierStatementCode) return
      this.$api
        .finCarrierStatementDetailApi({
          carrierStatementCode: this.params.carrierStatementCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
  .primaryfont {
    color: #007bff
  }
</style>
